import fetch from '../fetch';
import { errorMessages, familyName, fulfillmentStatuses } from '../../constants';
import getOneOffer from '../offers/getOne';
import initializeEcd from '../ecd/initialize';
import throwError from '../error/throw';
import { CLEAR_ERROR } from '../../reducers/error';

export const FETCH_SUBSCRIPTIONS = 'FETCH_SUBSCRIPTIONS';
export const SUBSCRIPTIONS_FETCHED = 'SUBSCRIPTIONS_FETCHED';
export const FAILED_FULFILLMENT_ERROR_KEY = 'failed-fulfillment-status';

export default () => async dispatch => {
  dispatch({ type: FETCH_SUBSCRIPTIONS });

  const fetched = {
    type: SUBSCRIPTIONS_FETCHED,
  };

  try {
    const subscriptions = await dispatch(fetch('/subscriptions'));
    const enrichedSubscriptions = subscriptions.data.map(subscription => ({
      ...subscription,
    }));

    fetched.payload = { subscriptions: enrichedSubscriptions };

    const hasAllProductFeatures = enrichedSubscriptions?.[0]?.fulfillmentStatus === fulfillmentStatuses.succeeded;
    const firstSubscription = subscriptions.data?.[0] || {};
    const hasPlanCode = Boolean(firstSubscription.planCode);

    const subscriptionFamily = firstSubscription.family;
    const subscriptionName = familyName[subscriptionFamily] || 'subscription';

    if (!hasAllProductFeatures) {
      const errorHeading = hasPlanCode
        ? `We're working on activating all your ${subscriptionName} benefits. Please try again later`
        : errorMessages.someDataMissing;
      const errorMessagesArray = hasPlanCode ? [] : [errorMessages.technicalIssues];

      dispatch(
        throwError(
          {
            heading: errorHeading,
            messages: errorMessagesArray,
          },
          {
            persist: true,
            key: FAILED_FULFILLMENT_ERROR_KEY,
            page: 'home',
          }
        )
      );
    } else {
      dispatch({ type: CLEAR_ERROR, payload: FAILED_FULFILLMENT_ERROR_KEY });
    }

    // The price returned by the Subscriptions API is no longer accurate so we use the offerId to call the Offers
    // service, which is still accurate
    const activeSubscription = enrichedSubscriptions.find(s => s.active);
    if (activeSubscription) {
      await getOneOffer(dispatch, activeSubscription.offerId);
    }
  } catch (error) {
    const errorMessage = {
      messages: [errorMessages.default],
    };
    fetched.error = true;
    fetched.payload = new Error(JSON.stringify(errorMessage));
  }
  dispatch(fetched);
  dispatch(initializeEcd());
};
